import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function PasswordField({ value, onChange, newPassword = false, disabled = false }) {
  const { t } = useTranslation('auth');
  const [visible, setVisible] = useState(false);
  return <div className="auth-field">
    <label htmlFor="password">{t('login.password')}</label>
    <div className="auth-password">
      <input id="password" name="password" type={visible ? 'text' : 'password'} value={value} onChange={onChange}
        autoComplete={newPassword ? 'new-password' : 'current-password'} required minLength={newPassword ? 8 : undefined}
        maxLength={4096} disabled={disabled} aria-describedby={newPassword ? 'password-hint' : undefined} dir="ltr" />
      <button type="button" className="auth-password-toggle" onClick={() => setVisible(!visible)} aria-pressed={visible}
        aria-label={t(visible ? 'shared.hidePassword' : 'shared.showPassword')}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
          <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" /><circle cx="12" cy="12" r="3" />
          {visible && <path d="m3 3 18 18" />}
        </svg>
      </button>
    </div>
    {newPassword && <p className="auth-hint" id="password-hint">{t('signup.passwordHint')}</p>}
  </div>;
}
